import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { QueryComponent } from './query-interface/components/query/query.component';
import { QueryResultComponent } from './query-interface/components/query-result/query-result.component';
import { HomeComponent } from './home/home.component';
import { DataIngestionComponent } from './data-ingestion/components/data-ingestion/data-ingestion.component';
import { LoginComponent } from './shared/components/login/login.component';
import { AuthGuard } from './shared/services/auth-guard.service';
import { EntitlementGuard } from './shared/services/entitlement.guard';
import { DataConnectionComponent } from './data-connection/components/data-connection/data-connection.component';
import { CreateDataConnectionComponent } from './data-connection/components/create-data-connection/create-data-connection.component';
import { UsersComponent } from './users/components/users/users.component';
import { BiComponent } from './bi/component/bi/bi.component';
import { BuildChartComponent } from './bi/component/build-chart/build-chart.component';
import { ManageChartsComponent } from './bi/component/manage-charts/manage-charts.component';
import { CreateDashboardComponent } from './bi/component/create-dashboard/create-dashboard.component';
import { ManageDashboardsComponent } from './bi/component/manage-dashboards/manage-dashboards.component';
import { BuildModelComponent } from './ml/components/build-model/build-model.component';
import { ModelHistoryComponent } from './ml/components/model-history/model-history.component';
import { MlComponent } from './ml/components/ml/ml.component';
import { ViewModelComponent } from './ml/components/view-model/view-model.component';
import { CollaborationComponent } from './collaboration/components/collaboration/collaboration.component';
import { CollaborationListComponent } from './collaboration/components/collaboration-list/collaboration-list.component';
import { CreateCollaborationComponent } from './collaboration/components/create-collaboration/create-collaboration.component';
import { ViewCollaborationInviteComponent } from './collaboration/components/view-collaboration-invite/view-collaboration-invite.component';
import { CollaborationDatasetComponent } from './collaboration/components/collaboration-dataset/collaboration-dataset.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'query',
        children: [
          {
            path: '',
            component: QueryComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'result/:queryId',
            component: QueryResultComponent,
            canActivate: [AuthGuard],
            // @TODO to be added after issue fixed with EntitlementGuard
            // canActivate: [EntitlementGuard],
            // data: { entitlements: ['app.dcr-portal.query-history.result'] },
          },
          {
            path: 'edit/:queryId',
            component: QueryComponent,
            canActivate: [AuthGuard, EntitlementGuard],
            data: { entitlements: ['app.dcr-portal.query-history.action.edit'] },
          },
        ],
      },
      {
        path: 'data-ingestion',
        component: DataIngestionComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'data-connection',
        component: DataConnectionComponent,
        canActivate: [AuthGuard, EntitlementGuard],
        data: { entitlements: ['app.dcr-portal.data-connection.action.view'] },
      },
      {
        path: 'data-connection/create',
        component: CreateDataConnectionComponent,
        canActivate: [AuthGuard, EntitlementGuard],
        data: {
          entitlements: ['app.dcr-portal.data-connection.action.create', 'app.dcr-portal.data-connection.action.edit'],
        },
      },
      {
        path: 'data-connection/edit/:connectionId',
        component: CreateDataConnectionComponent,
        canActivate: [AuthGuard, EntitlementGuard],
        data: {
          entitlements: ['app.dcr-portal.data-connection.action.create', 'app.dcr-portal.data-connection.action.edit'],
        },
      },
      {
        path: 'data-connection-mapping/create/:connectionId',
        component: CreateDataConnectionComponent,
        canActivate: [AuthGuard, EntitlementGuard],
        data: {
          entitlements: ['app.dcr-portal.data-connection.action.create', 'app.dcr-portal.data-connection.action.edit'],
        },
      },
      {
        path: 'data-connection-mapping/edit/:connectionId/:tableName',
        component: CreateDataConnectionComponent,
        canActivate: [AuthGuard, EntitlementGuard],
        data: {
          entitlements: ['app.dcr-portal.data-connection.action.create', 'app.dcr-portal.data-connection.action.edit'],
        },
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [AuthGuard, EntitlementGuard],
        data: {
          entitlements: [
            'app.dcr-portal.user-management.view',
            'app.dcr-portal.user-management.action.create',
            'app.dcr-portal.user-management.action.edit',
          ],
        },
      },
      {
        path: 'bi',
        component: BiComponent,
        children: [
          { path: '', redirectTo: 'build-chart', pathMatch: 'full' },
          { path: 'build-chart', component: BuildChartComponent },
          { path: 'manage-charts', component: ManageChartsComponent },
          { path: 'create-dashboard', component: CreateDashboardComponent },
          { path: 'manage-dashboards', component: ManageDashboardsComponent },
          { path: 'edit-chart/:chartId', component: BuildChartComponent },
          { path: 'edit-dashboard/:dashboardId', component: CreateDashboardComponent },
          { path: 'view-chart/:chartId', component: BuildChartComponent },
        ],
        canActivate: [AuthGuard, EntitlementGuard],
        data: {
          entitlements: ['app.dcr-portal.bi.all'],
        },
      },
      {
        path: 'ml',
        component: MlComponent,
        children: [
          { path: '', redirectTo: 'build', pathMatch: 'full' },
          { path: 'build', component: BuildModelComponent },
          { path: 'history', component: ModelHistoryComponent },
          { path: 'view-model/:modelId', component: ViewModelComponent },
        ],
        canActivate: [AuthGuard, EntitlementGuard],
        data: {
          entitlements: ['app.dcr-portal.ml.all'],
        },
      },
      {
        path: 'collaboration',
        canActivate: [AuthGuard, EntitlementGuard],
        data: {
          entitlements: ['app.dcr-portal.collaboration.all'],
        },
        children: [
          {
            path: '',
            component: CollaborationComponent,
            children: [
              {
                path: 'list',
                component: CollaborationListComponent,
              },
              { path: '', redirectTo: 'list', pathMatch: 'full' },
            ],
          },
          {
            path: 'create',
            component: CreateCollaborationComponent,
          },
          {
            path: 'view-invitation/:collaborationId',
            component: ViewCollaborationInviteComponent,
          },
          {
            path: 'dataset',
            component: CollaborationDatasetComponent,
          },
          {
            path: 'edit/:collaborationId',
            component: CreateCollaborationComponent,
          },
        ],
      },
      {
        path: '**',
        redirectTo: '/home',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
